import { TranslateService } from '@ngx-translate/core';
import { DialogObject } from '../../../../components/dialog/dialog.types';
import { ContactRepository } from '../../../../store/contact-state/contact-state.repository';

interface getContactDeleteObjectProps {
  t: TranslateService;
  store?: ContactRepository;
  representation?: string | number;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getContactDeleteObject = ({ t, store, representation, action, toggleVisiblity }: getContactDeleteObjectProps): DialogObject => {
  return {
    title: t.instant('settings.contact.deleteConfirm', { representation: representation }),
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
